import React, { useLayoutEffect, useRef } from "react";
import { cn } from "@/lib/utils";

/** حقل نص يتمدد ويتقلص مع المحتوى (بدل Input يقصّ النص الطويل). */
export const GrowInput = ({ value, onChange, className, rows = 1, ...props }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "0px";
    el.style.height = `${Math.max(el.scrollHeight, 40)}px`;
  }, [value]);
  return (
    <textarea
      ref={ref}
      rows={rows}
      value={value ?? ""}
      onChange={onChange}
      className={cn(
        "w-full min-h-10 resize-none overflow-hidden rounded-md border px-3 py-2 text-sm leading-relaxed whitespace-pre-wrap break-words",
        "ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )}
      {...props}
    />
  );
};
